export default __webpack_public_path__ + "static/media/Pearl_9781843626350.1db91913.jpg";